// v3.4.594 — ترقيم صفحات A4 موحّد بين محرر قالب العقد ومعاينة المسودة (نفس الخوارزمية ونفس النتيجة)
// يقيس مواضع الكتل الفعلية (بلا تقدير لكل فقرة) ويحترم فاصل الصفحة من المحرر (.page-break) وفاصل Word
// (<br style="page-break-before:always">) — الصفحة الجديدة تبدأ عند أول كتلة لا يتّسع أسفلها في ارتفاع المحتوى.
export const A4 = { width: 794, height: 1123 };

const isEditorBreak = (el) => !!(el.classList && el.classList.contains("page-break"));
const hasWordBreak = (el) => !!(el.querySelector && el.querySelector('br[style*="page-break-before"], [style*="page-break-before:always"], [style*="page-break-before: always"]'));
// كتلة لا تحمل إلا فاصل صفحة (Word يضعه داخل فقرة فارغة) تُعامل كفاصل صريح
const isBreakOnly = (el) => isEditorBreak(el) || (hasWordBreak(el) && !String(el.textContent || "").replace(/ /g, " ").trim() && !(el.querySelector && el.querySelector("img,table")));

/** فكّ أغلفة div الأحادية (إعدادات الخط / WordSection) للوصول إلى الكتل الفعلية */
export function unwrapBlocks(root) {
  let r = root;
  while (r && r.children.length === 1 && r.children[0].tagName === "DIV" && r.children[0].children.length > 0 && !isEditorBreak(r.children[0])) r = r.children[0];
  return r;
}

/**
 * يقسّم كتل root إلى صفحات. يجب أن يكون root معروضًا في الصفحة (للقياس).
 * @returns {Array<{ blocks: Element[], forced: boolean }>} — forced: الصفحة بدأت بفاصل صريح
 */
export function paginateBlocks(root, contentHeight) {
  const blocks = Array.from(root.children);
  const pages = [];
  let cur = [], pageTop = null, forced = false, forceNext = false;
  const flush = (nextForced) => { if (cur.length) pages.push({ blocks: cur, forced }); cur = []; pageTop = null; forced = nextForced; };
  for (const el of blocks) {
    if (isBreakOnly(el)) { flush(true); forceNext = false; continue; }
    if (forceNext) { flush(true); forceNext = false; }
    const r = el.getBoundingClientRect();
    if (pageTop === null) pageTop = r.top;
    else if (r.height > 0 && r.bottom - pageTop > contentHeight) { flush(false); pageTop = r.top; }
    cur.push(el);
    if (hasWordBreak(el)) forceNext = true; // فاصل Word داخل فقرة فيها نص: ما بعدها يبدأ صفحة جديدة
  }
  if (cur.length) pages.push({ blocks: cur, forced });
  return pages;
}

/** ارتفاع منطقة المحتوى في صفحة A4 حسب إعدادات القالب (الترويسة/التذييل داخل الهامشين) */
export const contentHeightOf = (ps) => A4.height - (Number(ps && ps.marginTop) || 96) - (Number(ps && ps.marginBottom) || 96);
